import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { EProcessStatus } from 'core/dto';
import { ScreenUtilsService } from 'core/services';
import { Observable, combineLatest, map, of } from 'rxjs';
import { designerPaths } from '../../../designer.paths';


@Injectable({ providedIn: 'root' })
export class NotMobileGuard implements CanActivate {

  constructor(
    private readonly _router: Router,
    private readonly _screenUtilsService: ScreenUtilsService

  ) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    return combineLatest([of(this.isMobile()), this._screenUtilsService.screenSizeSubject]).pipe(
      map(([isMobile, screenSize]) => {
        if (isMobile || screenSize === 'xs' || screenSize === 'sm') {
          this._router.navigate([designerPaths.processOverview, EProcessStatus.WaitingForMe])
          return false
        }

        return true;
      })
    )

  }


  isMobile() {

    const checkRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return checkRegex.test(navigator.userAgent);
  }
}
